export default __webpack_public_path__ + "static/media/gallery_31.db711a5b.jpg";